import utils from '../../../modules/utils';
import API from '../../api/api';

function isTokenReceived(status) {
  return (status === 'PAYPAL_TOKEN_RECEIVED' || status === 'HOSTED_PAYMENT_TOKEN_RECEIVED');
}

function isReturningFromHostedPage(queryParams) {
  return !!utils.fn.getURIParam(queryParams, 'PayerID') || !!utils.fn.getURIParam(queryParams, 'ba_token');
}

function isProblemWithService(status) {
  return (status === 'PAYPAL_AUTHENTICATION_FAILED'
    || status === 'PAYPAL_CURRENTLY_UNAVAILABLE'
    || status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage() {
  return API.doAPIRequest('/v2/return-from-hosted/paypal');
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
